import { ChangeEventArgs as CbChangeEventArgs, CheckBoxComponent } from '@syncfusion/ej2-react-buttons'
import CustomCard from '../../../components/CustomCard.tsx'
import { SelectedEventArgs, TextBoxComponent, UploaderComponent, UploadingEventArgs } from '@syncfusion/ej2-react-inputs'
import { Controller, useFormContext } from 'react-hook-form'
import { HtmlEditor, Link, QuickToolbar, RichTextEditorComponent, Inject, Toolbar, Table, ChangeEventArgs } from '@syncfusion/ej2-react-richtexteditor'
import { FC, useEffect, useRef, useState } from 'react'
import { protectedResources } from '../../../global/config.tsx'
import { useOidcAccessToken, useOidcUser } from '@axa-fr/react-oidc'
import { OidcUserExtendedInfo } from '../../../types/OidcUserExtendedInfo.tsx'

interface WebDataProps {
  avatarImgSrc: Blob | undefined
}

export const WebData: FC<WebDataProps> = ({ avatarImgSrc }) => {
  const [picturePreviewSrc, setPicturePreviewSrc] = useState<string>('')

  const refFileUploader = useRef<UploaderComponent | null>(null)
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext()
  const { accessToken } = useOidcAccessToken()
  const { oidcUser } = useOidcUser<OidcUserExtendedInfo>()

  const asyncSettings = {
    chunkSize: 102400,
    retryAfterDelay: 3000,
    retryCount: 5,
    saveUrl: protectedResources.apiList.createFile,
  }

  const toolbarSettings = {
    items: [
      'FormatPainter',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      'SuperScript',
      'SubScript',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      'OrderedList',
      'UnorderedList',
      '|',
      'Outdent',
      'Indent',
      '|',
      'CreateLink',
      'Image',
      'CreateTable',
      '|',
      'SourceCode',
      'Undo',
      'Redo',
    ],
  }

  useEffect(() => {
    // Wenn bereits Avatar gespeichert ist
    if (avatarImgSrc) {
      imagePreview(avatarImgSrc)
    } else {
      // Wenn nicht, setze Transparentes 1-Pixel Bild, damit image src valid ist
      setPicturePreviewSrc('data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==')
    }
  }, [avatarImgSrc])

  const imagePreview = (file: Blob) => {
    console.log(file)
    const reader = new FileReader()
    // console.log(file)
    // if (file) console.log(URL.createObjectURL(file))

    // console.log(file)
    // if (file.rawFile instanceof Blob) {
    // }

    reader.onload = (e: any) => {
      // console.log(e)
      setPicturePreviewSrc(e.target.result)
    }

    reader.readAsDataURL(file as Blob)
  }

  // Bildvorschau
  const onFileSelected = (args: SelectedEventArgs) => {
    const file = args.filesData[0]
    const reader = new FileReader()
    reader.readAsDataURL(file.rawFile as Blob)

    reader.onloadend = function() {
      setPicturePreviewSrc(reader.result as string)
    }
  }

  // Resette Bildvorschau src zu transparentem 1-pixel Bild
  const onFileRemoved = () => {
    setPicturePreviewSrc('data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==')
  }

  const handleChangeRte = (args: ChangeEventArgs) => {
    setValue('webOtherInformation', args.value)
  }

  const onUploadBegin = (args: UploadingEventArgs) => {
    args.customFormData = [{ mimeType: (args.fileData.rawFile as Blob).type }, { sub: oidcUser.sub }, { fileTypeId: 1 }]
    if (args.currentRequest) {
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${accessToken}`)
    }
  }

  const onChunkUploadBegin = (args: UploadingEventArgs) => {
    args.customFormData = [{ mimeType: (args.fileData.rawFile as Blob).type }, { sub: oidcUser.sub }, { fileTypeId: 1 }]
    if (args.currentRequest) {
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${accessToken}`)
    }
  }

  return (
    <CustomCard header="Web Informationen">
      <div className="formRow">
        <div className="formCol verticalCustom">
          <div className="formCol alignCenter">
            <TextBoxComponent placeholder="Name" floatLabelType="Always" {...register('webName')} />

            <Controller control={control} name="webName_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
          </div>
          <div className="formCol alignCenter">
            <TextBoxComponent placeholder="Telefon" floatLabelType="Always" {...register('webPhone')} />
            <Controller control={control} name="webPhone_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
          </div>
          <div className="formCol alignCenter" style={{ gap: 0, flexWrap: 'wrap' }}>
            <div className="formCol alignCenter" style={{ flex: 1 }}>
              <TextBoxComponent placeholder="E-Mail" floatLabelType="Always" {...register('webEmail', { pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Ungültige E-Mail Adresse.' } })} />
              <Controller control={control} name="webEmail_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
            </div>
            <p className="errorMsg" style={{ width: '100%', marginBottom: 0, top: '-8px' }}>
              {(errors.webEmail?.message as string) || null}
            </p>
          </div>
          <div className="formCol alignCenter">
            <TextBoxComponent placeholder="Internet" floatLabelType="Always" {...register('webInternet')} />
            <Controller control={control} name="webInternet_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
          </div>
        </div>
        <div className="formCol imgUpload customUpload">
          <Controller control={control} name="webAvatar_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
          <div className="imgPreviewContainer">
            <img className="imgPreview" src={picturePreviewSrc} />
          </div>

          <UploaderComponent
            ref={refFileUploader}
            type="file"
            autoUpload={true}
            maxFileSize={1000000}
            allowedExtensions=".jpg,.jpeg,.png"
            multiple={false}
            selected={onFileSelected}
            removing={onFileRemoved}
            uploading={onUploadBegin}
            chunkUploading={onChunkUploadBegin}
            asyncSettings={asyncSettings}
          />
        </div>
      </div>
      <div>
        <span style={{ display: 'inline-block', marginBottom: '20px', marginRight: '20px' }}>Zusätzliche Informationen</span>
        <Controller control={control} name="webOtherInformation_public" defaultValue={false} render={({ field }) => <CheckBoxComponent label="Public" checked={field.value} change={(e: CbChangeEventArgs) => field.onChange(e.checked)} />} />
      </div>

      <Controller
        control={control}
        name="webOtherInformation"
        render={({ field }) => (
          <RichTextEditorComponent
            value={field.value}
            height={350}
            toolbarSettings={toolbarSettings}
            enableXhtml={true}
            change={(e) => {
              field.onChange(e.value)
              handleChangeRte(e)
            }}
          >
            <Inject services={[HtmlEditor, QuickToolbar, Toolbar, Link, Table]} />
          </RichTextEditorComponent>
        )}
      />
    </CustomCard>
  )
}
